import { http } from '@/lib/ats-https';

/**
 * Interview-plan scorecard-template service.
 *
 * Relocated here from
 * `src/pages/ats-job-creation/tabs/interview-plan/api/api.js` so cross-feature
 * consumers (the KInterviewScheduler scorecard hooks) stop importing into the
 * ats-job-creation page layer. The original module re-exports this for
 * within-feature callers.
 */
const getScoreCardTemplates = async (queryParam: string) => {
  const response = await http.get(
    `ats_scorecards/list_templates?${queryParam}`
  );
  return response.data?.ats_scorecards;
};

export const API_SERVICE = {
  getScoreCardTemplates,
};
